/// <amd-module name="Repos/Discussion/DiscussionThread" />
export { DiscussionThread } from "./Components/DiscussionThread";
export { DiscussionThreadModel, IDiscussionThreadModelProps, newThread } from "./Models/DiscussionThreadModel";
